<template lang="html">
  <div class="">
    <v-window v-model="window">
      <v-window-item key="0">
        <v-container
          grid-list-xl
          fluid
          pa-6
        >
          <!-- <v-layout wrap>
            <v-flex xs12 mb-2 class="headline">Client Path</v-flex>
          </v-layout> -->
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              sm6
              md4
              xl3
            >
              <SiStatCard
                :value="identityCount"
                label="Known Identities"
                icon="face"
                color="cyan"
                :format="v => !isNaN(v) ? Number(v).toFixed(0) : 0"
              />
            </v-flex>
            <v-flex
              xs12
              sm6
              md4
              xl3
            >
              <SiStatCard
                :value="fingerprintCount"
                label="Unidentified Fingerprints"
                icon="fingerprint"
                color="blue-grey"
                :format="v => !isNaN(v) ? Number(v).toFixed(0) : 0"
              />
            </v-flex>
            <v-flex
              xs12
              sm6
              md4
              xl3
            >
              <SiStatCard
                :value="(duplicatedFingerprints || []).length"
                label="Duplicated Fingerprints"
                icon="exposure_plus_2"
                color="grey"
                :format="v => !isNaN(v) ? Number(v).toFixed(0) : 0"
              />
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-title class="white pt-0">
          <v-switch
            v-model="showAll"
            :label="!showAll ? 'Only known identities' : 'All identities'"
            hide-details
          />
          <v-spacer />
          <v-flex
            xs12
            sm6
            md4
            pa-0
          >
            <v-text-field
              v-model="search"
              prepend-icon="search"
              label="Search"
              single-line
              clearable
              hide-details
            />
          </v-flex>
        </v-card-title>
        <v-data-table
          :headers="tableHeaders"
          :items="showAll ? identityList : identityList.filter( i => i.type === 'identity')"
          sort-by="last"
          sort-desc
          :search="search"
          :items-per-page="15"
          class="cursor-pointer"
          @click:row=" item => $router.push(`clientpath/${item.type}/${item.id}`)"
        >
          <template #item.type="{ item }">
            <v-tooltip right>
              <template #activator="{on}">
                <v-icon
                  :color="hasDuplidatedFingerprint(item.fingerprints) ? 'error' : ''"
                  v-on="on"
                >
                  {{ item.type === 'identity' ? 'account_circle' : 'fingerprint' }}
                </v-icon>
              </template>
              <div class="">
                Duplicated Fingerprint(s):
              </div>
              <div
                v-for="(f, fpId) in filterFingerprints(item.fingerprints)"
                :key="fpId"
              >
                {{ fpId }}
              </div>
            </v-tooltip>
          </template>
          <template #item.calculationsTotal="{ item }">
            <v-tooltip
              left
              :disabled="!item.calculationsTotal || item.calculationsTotal <= 0"
            >
              <template #activator="{ on }">
                <div>
                  {{ item.calculationsTotal || '' }}
                  <span v-on="on"><v-icon
                    right
                    :color="item.calculationsTotal > 0 ? 'grey' :'grey lighten-3'"
                  >assessment</v-icon></span>
                </div>
              </template>
              <v-layout
                v-for="c in filterCalculations(item.calculations)"
                :key="c.id"
              >
                <v-flex mr-2>
                  {{ calculatorVairantName(c.id) }}:
                </v-flex>
                <v-flex
                  class="font-weight-bold"
                  shrink
                >
                  {{ c.count }}
                </v-flex>
              </v-layout>
            </v-tooltip>
          </template>
          <template #item.last="{ item }">
            <span
              v-if="item.last"
              class="text-no-wrap"
            >
              {{ _formatDateTime(item.last) }} - <i>{{ _timeAgo(item.last) }}</i>
            </span>
          </template>
          <template #item.revenue="{ item }">
            <div class="text-no-wrap text-right ">
              {{ item.revenue ? _$(item.revenue) : '-' }}
            </div>
          </template>
        </v-data-table>
      </v-window-item>
      <v-window-item key="1">
        <ClientPathView :identities="_unSortObject(identityList)" />
      </v-window-item>
    </v-window>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { forEach, cloneDeep } from 'lodash'
import helpers from '@/mixins/helpers'
import binder from '@/mixins/binder'

export default {
  mixins: [ helpers, binder ],
  props: {

  },
  data () {
    return {
      search: '',
      fingerprints: {},
      showAll: false,
      identities: {},
      identityList: [],
      duplicatedFingerprints: 0,
      // identitiesFiltered: {},
      // identitiesFilteredSorted: [],
      tableHeaders: [
        { text: 'Type', value: 'type', sortable: false, width: '30px' },
        { text: 'Name', value: 'name' },
        { text: 'Email', value: 'email' },
        { text: 'Location', value: 'location' },
        { text: 'Last Seen', value: 'last' },
        { text: 'Calculations', value: 'calculationsTotal', align: 'end' },
        { text: 'Interactions', value: 'cnt', align: 'end' },
        { text: 'Revenue', value: 'revenue', align: 'end' }
      ],
      userStats: {}
    }
  },
  computed: {
    ...mapGetters(['_calculators']),
    window () {
      return this.$route.params.sub ? 1 : 0
    },
    identityCount () {
      return (this.identityList.filter(i => i.type === 'identity') || []).length
    },
    fingerprintCount () {
      return (this.identityList.filter(i => i.type === 'fingerprint') || []).length
    }
  },
  watch: {
    fingerprints () {
      this.setIdentities()
    },
    identities () {
      this.setIdentities()
    }
  },
  beforeMount () {
    // this.$bindxxx(rtdb.ref(`stats/clients`), 'userStats')
    // this.$bindxxx(rtdb.ref(`clientPath/_indexFingerprints`), 'fingerprints', true)
    // this.$bindxxx(rtdb.ref(`clientPath/identities`), 'identities', true)
    this.$bindRtdb('userStats', `stats/clients`)
    this.$bindRtdb('fingerprints', `clientPath/_indexFingerprints`, { loader: true })
    this.$bindRtdb('identities', `clientPath/identities`, { loader: true })
    this.$store.commit('set_appBarTitle', {title: 'Client Path', icon: 'track_changes'})
  },
  methods: {
    calculatorVairantName (statId = '') {
      let [calculatorId, variantId] = statId.split('_') || []
      let variants = (this._calculators[calculatorId] || {}).variants || {}
      return (variants[variantId] || {}).name || ''
    },
    identityStats (email) {
      let clientId = btoa(email)
      let stats = this.userStats[clientId] || {}
      return Object.keys(stats).filter(k => k.substr(0, 1) !== '_').map(k => stats[k]).reduce((t, cv) => t = Number(t) + Number(cv), 0)
    },
    hasDuplidatedFingerprint (fingerprints) {
      fingerprints = Object.keys(fingerprints)
      let dupLength = (this.duplicatedFingerprints || []).length
      let fpLength = (fingerprints || []).length
      let combineLength = [...new Set(this.duplicatedFingerprints.concat(fingerprints))].length
      return combineLength !== dupLength + fpLength
    },
    setIdentities () {
      let identities = []
      let assignedFingerprints = []
      let counts = {}

      forEach(cloneDeep(this.identities), (identity, id) => {
        let i = 0
        let clientId = btoa((identity || {}).email)
        identity.id = id
        identity.cnt = 0
        identity.last = 0
        identity.type = 'identity'
        identity.revenue = (this.userStats[btoa(identity.email)] || {})._revenue || 0
        identity.calculationsTotal = this.identityStats(identity.email)
        identity.calculations = this.userStats[clientId] || {}
        identity.location = ''

        for (var fp in identity.fingerprints) {
          if (!this.fingerprints[fp]) continue
          identity.location = `${identity.location}${i > 0 ? ' | ' : ''}${this.fingerprints[fp].location}`
          identity.cnt += this.fingerprints[fp].cnt
          identity.last = Math.max(new Date(identity.last), new Date((this.fingerprints[fp] || {}).last))
          identity.fingerprints[fp] = this.fingerprints[fp]
          assignedFingerprints.push(fp)
          i++
        }

        identities.push(identity)
      })
      var fingerprints = this._sortObject(cloneDeep(this.fingerprints)).filter(f => !assignedFingerprints.includes(f.id))

      forEach(fingerprints, (fp) => {
        // fp.id = fpId
        fp.type = 'fingerprint'
        fp.name = fp.id
        fp.email = fp.id
        fp.fingerprints = { [fp.id]: fp }
        identities.push(fp)
      })

      assignedFingerprints.forEach(x => { counts[x] = (counts[x] || 0) + 1 })

      this.duplicatedFingerprints = Object.keys(counts).filter(k => counts[k] > 1)
      this.identityList = identities
    },
    filterFingerprints (fingerprints) {
      // TODO: check this works
      return this._sortObject(fingerprints).filter(f => this.duplicatedFingerprints.includes(f.id))
    },
    filterCalculations (calculations) {
      let filteredStats = []
      forEach(calculations, (count, id) => {
        if (id.substr(0,1) !== '_') filteredStats.push({ id, count })
      })
      return filteredStats      
    }
  }
}
</script>

<style lang="css" scoped>

</style>
